import React, { useState, useEffect } from 'react'
import { Routes, Route, Navigate, useLocation, useParams } from 'react-router-dom'
import { StateMachineProvider, createStore } from 'little-state-machine'
import { storeInitState } from './store'
import { SpoeumLayout } from './layout'
import {
	HomeView,
	TraningProgramView,
	AboutView,
	CaddyAcademy,
	LoginView,
	FindIdView,
	ResetPasswordView,
	RegisterHomeView,
	RegisterMainView,
	RegisterTourProView,
	RegisterTourCaddieView,
	RegisterHouseCaddieView,
	RegisterAgencyView,
	MyAccountView,
	MyInfoView,
	MyPaymentView,
	MyContractInfoView,
	ScheduleCheckView,
	RequesterDetailView,
	OfferListView,
	OfferDetailView,
	ProposalListView,
	ProposalDetailView,
	ProManagementView,
	OneInQuireListView,
	InterestedHumanResourcesView,
	AgencyManagementView,
	ContractProcessingDetailView,
	ContractProcessingView,
	ContractDetailView,
	TourRecruitInfoFormView,
	RecruitTourSelectView,
	RecruitTypeSelectView,
	RecruitListView,
	MatchingIndexView,
	MatchingHumanResourceDetailView,
	MatchingCompleteView,
	ProposalTourSelectView,
	ProposalTypeSelectView,
	ProposalAnnualTypeSelectView,
	TourProposalInfoFormView,
	AnnualProposalInfoFormView,
	PointChargeView,
	FixPaymentView,
	PaymentFailView,
	PaymentCompletedView,
	RecruitAnnualTypeSelectView,
	AnnualRecruitInfoFormView,
	SponsorshipListView,
	SponsorshipInquiryCreateView,
	SponsorshipInquiryDetailView,
	SponsorshipInquiryUpdateView,
	CompleteNiceView,
	PaymentView,
	OneInquiryDetailView,
	OnboardDefaultView,
	JobPostFirstPageView,
	JobPostSecondPageView,
} from './pages'
import JobPostThirdPageView from './pages/jobpost/JobPostThirdPageView'
import JobPostFourthPageView from './pages/jobpost/JobPostFourthPageView'
import { FirstTourproSignup } from './pages/signup/FirstSignup/FirstTourproSignup/FirstTourproSignup'
import { RecruitDetailView } from './pages/recruit/RecruitDetailView'
import { formInitState, RequireAuth, ScrollToTop, useAuthStatus } from './utils'
import { useServiceConfig } from './hooks'
import { NiceTestView } from './pages/NiceTestView'
import SignupVerificationForm from './pages/signup/SignupVerificationForm'
import CertifyComplete from './pages/signup/CertifyComplete'
import ChooseMemberType from './pages/signup/ChooseMemberType'
import OnboardingNext from './pages/onboarding/OnboardingNext'
import { Home } from './pages/home/Home'
import { SearchCaddie } from './pages/search/SearchCaddie'
import SearchPro from './pages/search/SearchPro'
import { SearchMatch } from './pages/search/SearchMatch'
import Landing from './pages/landing/landingPage/Landing'

import OfferDefaultPage from './pages/offers/create/OfferDefaultPage'
import { OfferSecondPage } from './pages/offers/create/OfferSecondPage'
import OfferThirdPage from './pages/offers/create/OfferThirdPage'
import OfferFourthPage from './pages/offers/create/OfferFourthPage'
import CaddieDisplay from './components/CaddieDisplay/CaddieDisplay'
import { Login } from './pages/auth/Login'
import { OfferManagement } from './pages/offers/manage/OfferManagement'
import { OfferManagementDetail } from './pages/offers/manage/OfferManagementDetail'
import { PreContractManagementDefaultView } from './pages/precontractmanagement/PreContractManagementDefaultView'
import ReNegotiationView from './pages/offers/manage/ReNegotiationView'
import { ContractManagementListView } from './pages/contractmanagement/ContractManagementListView'
import { ContractManagementDetailView } from './pages/contractmanagement'
import { FindCredentials } from './pages/auth/FindCredentials'
import { MyInfo } from './pages/myinfo/MyInfo'
import { BasicInfo } from './pages/myinfo/BasicInfo'
import { PreferredContract } from './pages/myinfo/PreferredContract'
import { UpcomingTournaments } from './pages/myinfo/UpcomingTournaments'
import { Notifications } from './pages/notifications/Notifications'
import { NoticeMain } from './pages/board/NoticeMain'
import PostManageDefaultView from './pages/postManage/postManageDefaultView'
import PostManageEdit from './pages/postManage/PostManageEdit'
import JobPostManageDetailView from './pages/postManage/JobPostManageDetailView'
import JobPostPublicListView from './pages/jobpost/JobPostPublicListView'
import JobPostPublicDetailView from './pages/jobpost/JobPostPublicDetailView'
import PaymentManageDefaultPage from './pages/paymentManage/PaymentManageDefaultPage'
import PaymentManageDetailPage from './pages/paymentManage/PaymentManageDetailPage'
import SignupTourCaddieFirstPage from './pages/signup/tourCaddie/SignupTourCaddieFirstPage'
import SignupTourCaddieVerfication from './pages/signup/tourCaddie/SignupTourCaddieVerfication'
import { OnboardingCaddieDomestic } from './pages/onboarding/OnboardingCaddieDomestic'

import ProInfo from './pages/myinfo/ProInfo'
import CaddieInfo from './pages/myinfo/CaddieInfo'
import BankAccount from './pages/myinfo/BankAccount'

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT
const CDN_ENDPOINT = process.env.REACT_APP_CDN_ENDPOINT
const PROFILE_BUCKET = process.env.REACT_APP_S3_PROFILE_BUCKET
const BUSINESS_BUCKET = process.env.REACT_APP_S3_BUSINESS_BUCKET

/** 예전 /job-posts URL → /posts 로 리다이렉트 */
function RedirectLegacyJobPostDetail() {
	const { postId } = useParams()
	return <Navigate to={`/posts/${postId}`} replace />
}

// 인증 체크용 래퍼 컴포넌트
function PrivateRoute({ children }) {
	const [auth] = useAuthStatus()
	const token = localStorage.getItem('token')
	console.log('auth:', auth)
	return auth.isAuthentication && token ? children : <Login replace />
}

// global state
createStore(storeInitState)
// JaesangKim 주석 추가 1
function APP() {
	const location = useLocation()
	// 찾기 페이지 진입 시마다(앞으로가기/뒤로가기 포함) key 변경 → SearchMatch 새로 마운트, 상태 초기화
	const [searchEntryKey, setSearchEntryKey] = useState(0)
	useEffect(() => {
		if (location.pathname === '/search') setSearchEntryKey((k) => k + 1)
	}, [location.pathname])

	// 서비스 설정 정보 조회
	const { serviceConfig, isLoading: isServiceConfigLoading, mode, year } = useServiceConfig()

	// 서비스 설정 로딩 중이면 로딩 표시 (선택사항)
	if (isServiceConfigLoading) {
		console.log('서비스 설정 로딩 중...')
	}

	// 서비스 설정 정보가 로드되면 콘솔에 출력
	if (serviceConfig) {
		console.log('서비스 설정:', { mode, year })
	}

	return (
		<StateMachineProvider>
			<ScrollToTop />
			<Routes>
				{/* 레이아웃이 필요 없는 페이지들 */}
				<Route path="/" element={<Landing />} />
				<Route path="/login" element={<Login />} />
				<Route path="/auth/find-credentials" element={<FindCredentials />} />
				{/* 가입 관련 */}
				<Route path="/signup" element={<ChooseMemberType />} />
				<Route path="signup/tour-pro" element={<FirstTourproSignup />} />
				<Route path="signup/tour-caddie" element={<SignupTourCaddieFirstPage />} />
				<Route
					path="signup/tour-caddie/verification"
					element={<SignupTourCaddieVerfication />}
				/>
				<Route path="signup/tour-pro/verification" element={<SignupVerificationForm />} />
				<Route path="/certify/complete" element={<CertifyComplete />} />
				{/* 온보딩 관련 */}
				<Route path="/onboarding/caddie-domestic" element={<OnboardingCaddieDomestic />} />
				<Route
					path="/onboarding/select-tournament"
					element={
						<RequireAuth>
							<OnboardDefaultView />
						</RequireAuth>
					}
				/>
				<Route
					path="/onboarding/contract-info"
					element={
						<RequireAuth>
							<OnboardingNext />
						</RequireAuth>
					}
				/>
				<Route
					path="/nice"
					element={
						<NiceTestView API_ENDPOINT={API_ENDPOINT} CDN_ENDPOINT={CDN_ENDPOINT} />
					}
				/>
				<Route path="/training-program" element={<CaddyAcademy />} />
				<Route path="/notice" element={<NoticeMain />} />
				{/* 레이아웃이 필요한 대시보드 페이지들 - RequireAuth로 한 번에 감싸기 */}
				<Route
					element={
						<RequireAuth>
							<SpoeumLayout />
						</RequireAuth>
					}>
					<Route path="/home" element={<Home />} />
					<Route path="/myinfo" element={<MyInfo />} />
					<Route path="/myinfo/basicinfo" element={<BasicInfo />} />
					<Route path="/myinfo/proinfo" element={<ProInfo />} />
					<Route path="/myinfo/caddieinfo" element={<CaddieInfo />} />
					<Route path="/myinfo/bank-account" element={<BankAccount />} />
					<Route path="/myinfo/preferred-contract" element={<PreferredContract />} />
					<Route path="/myinfo/upcomingtournaments" element={<UpcomingTournaments />} />
					<Route path="/notifications" element={<Notifications />} />
					<Route path="/search" element={<SearchMatch key={searchEntryKey} />} />
					<Route path="/search/caddie" element={<Navigate to="/search" replace />} />
					<Route path="/search/pro" element={<Navigate to="/search" replace />} />
					<Route
						path="/posts/create/type"
						element={<JobPostFirstPageView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/posts/create/tour"
						element={<JobPostSecondPageView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route path="/offer/create/type" element={<OfferDefaultPage />} />
					<Route path="/offer/create/tour" element={<OfferSecondPage />} />
					<Route path="/offer/create/terms" element={<OfferThirdPage />} />
					<Route path="/offer/create/confirm" element={<OfferFourthPage />} />

					<Route
						path="/posts/create/terms"
						element={<JobPostThirdPageView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/posts/create/confirm"
						element={<JobPostFourthPageView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/posts/edit"
						element={<Navigate to="/posts/manage/edit" replace />}
					/>
					<Route path="/offers" element={<OfferManagement />} />
					<Route path="/offers/:offerId" element={<OfferManagementDetail />} />
					<Route path="/precontracts" element={<PreContractManagementDefaultView />} />
					<Route path="/offers/:offerId/renegotiation" element={<ReNegotiationView />} />
					<Route path="/contracts" element={<ContractManagementListView />} />
					<Route
						path="/contracts/:contractId"
						element={<ContractManagementDetailView />}
					/>
					<Route path="/settlements" element={<PaymentManageDefaultPage />} />
					<Route
						path="/settlements/:contractPaymentId"
						element={<PaymentManageDetailPage />}
					/>

					<Route path="/posts/manage/edit" element={<PostManageEdit />} />
					<Route path="/posts/manage/:postId" element={<JobPostManageDetailView />} />
					<Route path="/posts/manage" element={<PostManageDefaultView />} />
					<Route path="/posts/:postId" element={<JobPostPublicDetailView />} />
					<Route path="/posts" element={<JobPostPublicListView />} />
					<Route path="/job-posts" element={<Navigate to="/posts" replace />} />
					<Route path="/job-posts/:postId" element={<RedirectLegacyJobPostDetail />} />
					<Route path="/about" element={<AboutView />} />

					<Route
						path="/sponsorship"
						element={<SponsorshipListView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/sponsorship/:sponsorshipId"
						element={<SponsorshipInquiryDetailView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/sponsorship/create"
						element={<SponsorshipInquiryCreateView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/sponsorship/update/:sponsorshipId"
						element={<SponsorshipInquiryUpdateView API_ENDPOINT={API_ENDPOINT} />}
					/>

					<Route path="/old/login" element={<LoginView API_ENDPOINT={API_ENDPOINT} />} />
					<Route path="/find-id" element={<FindIdView API_ENDPOINT={API_ENDPOINT} />} />
					<Route
						path="/reset-password"
						element={<ResetPasswordView API_ENDPOINT={API_ENDPOINT} />}
					/>

					{/* <Route
						path="/certify/complete"
						element={<CompleteNiceView CDN_ENDPOINT={CDN_ENDPOINT} />}
					/> */}
					<Route path="/register" element={<RegisterHomeView />} />
					<Route
						path="/register/main"
						element={
							<RegisterMainView
								API_ENDPOINT={API_ENDPOINT}
								CDN_ENDPOINT={CDN_ENDPOINT}
							/>
						}
					/>
					<Route
						path="/register/tour-pro"
						element={<RegisterTourProView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/register/tour-caddie"
						element={<RegisterTourCaddieView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/register/house-caddie"
						element={<RegisterHouseCaddieView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/register/agency"
						element={<RegisterAgencyView API_ENDPOINT={API_ENDPOINT} />}
					/>

					<Route
						path="/mypages/contract-info"
						element={<MyContractInfoView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/mypages/account"
						element={<MyAccountView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/mypages/points"
						element={<PointChargeView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/mypages/payment"
						element={<MyPaymentView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path={'/mypages/interested-hr'}
						element={<InterestedHumanResourcesView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path={'/mypages/proposals'}
						element={
							<ProposalListView
								API_ENDPOINT={API_ENDPOINT}
								PROFILE_BUCKET={PROFILE_BUCKET}
							/>
						}
					/>
					<Route
						path={'/mypages/proposals/:proposalId'}
						element={<ProposalDetailView API_ENDPOINT={API_ENDPOINT} />}
					/>

					<Route
						path={'/mypages/offers'}
						element={<OfferListView API_ENDPOINT={API_ENDPOINT} />}
					/>

					<Route
						path={'/mypages/offers/:offerId'}
						element={<OfferDetailView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path={'/mypages/offers/requester'}
						element={<RequesterDetailView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path={'/mypages/pro-management'}
						element={<ProManagementView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path={'/mypages/agency-management'}
						element={<AgencyManagementView API_ENDPOINT={API_ENDPOINT} />}
					/>
					{/*<Route path={'/mypages/spoeum-manage'} element={<SpoeumManagerListView />} />*/}
					<Route
						path={'/mypages/contract-process'}
						element={<ContractProcessingView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path={'/mypages/contract-process/:contractId'}
						element={<ContractProcessingDetailView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path={'/mypages/contract/docs/:contractId'}
						element={<ContractDetailView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path={'/mypages/schedule'}
						element={<ScheduleCheckView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path={'/mypages/one-in-quire'}
						element={<OneInQuireListView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path={'/mypages/one-in-quire/:oneInquireId'}
						element={<OneInquiryDetailView API_ENDPOINT={API_ENDPOINT} />}
					/>

					<Route
						path="/matching"
						element={
							<MatchingIndexView
								API_ENDPOINT={API_ENDPOINT}
								PROFILE_BUCKET={PROFILE_BUCKET}
							/>
						}
					/>
					<Route
						path="/matching/:userId"
						element={
							<MatchingHumanResourceDetailView
								API_ENDPOINT={API_ENDPOINT}
								PROFILE_BUCKET={PROFILE_BUCKET}
							/>
						}
					/>
					<Route
						path="/matching/completed"
						element={<MatchingCompleteView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/proposal/create/type"
						element={<ProposalTypeSelectView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/proposal/create/tour"
						element={<ProposalTourSelectView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/proposal/create/annual-type"
						element={<ProposalAnnualTypeSelectView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/proposal/create/tour-info"
						element={<TourProposalInfoFormView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/proposal/create/annual-info"
						element={<AnnualProposalInfoFormView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/recruits"
						element={<RecruitListView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/recruits/:offerId"
						element={<RecruitDetailView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/recruits/create/contract-type"
						element={<RecruitTypeSelectView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/recruits/create/tour"
						element={<RecruitTourSelectView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/recruits/create/tour-info"
						element={<TourRecruitInfoFormView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/recruits/create/annual-type"
						element={<RecruitAnnualTypeSelectView API_ENDPOINT={API_ENDPOINT} />}
					/>
					<Route
						path="/recruits/create/annual-info"
						element={<AnnualRecruitInfoFormView API_ENDPOINT={API_ENDPOINT} />}
					/>
					{/*<Route*/}
					{/*	path="/recruits/apply"*/}
					{/*	element={<TourRecruitInfoFormView API_ENDPOINT={API_ENDPOINT} />}*/}
					{/*/>*/}

					<Route
						path="/payment"
						element={
							<PaymentView API_ENDPOINT={API_ENDPOINT} CDN_ENDPOINT={CDN_ENDPOINT} />
						}
					/>

					{/*<Route*/}
					{/*	path="/payment/completed"*/}
					{/*	element={*/}
					{/*		<PaymentCompletedView*/}
					{/*			API_ENDPOINT={API_ENDPOINT}*/}
					{/*			CDN_ENDPOINT={CDN_ENDPOINT}*/}
					{/*		/>*/}
					{/*	}*/}
					{/*/>*/}
					{/*<Route*/}
					{/*	path="/payment/fail"*/}
					{/*	element={*/}
					{/*		<PaymentFailView API_ENDPOINT={API_ENDPOINT} CDN_ENDPOINT={CDN_ENDPOINT} />*/}
					{/*	}*/}
					{/*/>*/}
				</Route>{' '}
				{/* SpoeumLayout 중첩 라우트 닫기 */}
			</Routes>
		</StateMachineProvider>
	)
}

export default APP
